import {
  checkmarkDoneOutline,
  constructOutline,
  pencilOutline,
  syncCircleOutline,
  timerOutline,
  trashBinOutline,
  warningOutline,
  removeCircleOutline,
} from "ionicons/icons";
import { StatusDetail } from "../@types/statusDetail";

export const statusDetail: StatusDetail[] = [
  {
    code: "preparing",
    module: "document",
    icon: constructOutline,
    color: "medium",
  },
  {
    code: "Pendiente Firma Digital",
    module: "document",
    icon: constructOutline,
    color: "medium",
  },
  {
    code: "pending",
    module: "document",
    icon: timerOutline,
    color: "primary",
  },
  {
    code: "Pendiente",
    module: "document",
    icon: timerOutline,
    color: "primary",
  },
  {
    code: "fulfilled",
    module: "document",
    icon: checkmarkDoneOutline,
    color: "success",
  },
  {
    code: "Completo",
    module: "document",
    icon: checkmarkDoneOutline,
    color: "success",
  },
  {
    code: "rejected",
    module: "document",
    icon: warningOutline,
    color: "danger",
  },
  {
    code: "abandoned",
    module: "document",
    icon: removeCircleOutline,
    color: "danger",
  },
  {
    module: "document",
    code: "anulled",
    icon: trashBinOutline,
    color: "danger",
  },
  {
    code: "correction",
    module: "document",
    icon: pencilOutline,
    color: "tertiary",
  },
  {
    code: "sync",
    module: "document",
    icon: syncCircleOutline,
    color: "secondary",
  },
];
